import { createRestApiClient } from '..';
import { getCountryCode } from '../../Utils/ForeignUtils';
import { getBrowserId, getUserToken, getWebUserId } from '../../Utils/helper';
import { fireApiHandler } from '../../Utils/PaymentUtils/instrumentation';

export const createCustomerId = () => {
  const restApiClient = createRestApiClient();
  const country_code = getCountryCode();
  // on Success Hit Add Order Api  addOrder(paymentMethod, discount, res?.data?.data?.customer_id);
  // on Failure Fire Error Instrumentation Event
  const api_url = 'api/saveCustomer';
  return restApiClient
    .request({
      method: 'POST',
      url: api_url,
      headers: {
        authorization: getUserToken(),
        country_code: country_code,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      fireApiHandler(api_url, err);
    });
};

export const mobileWebLogin = (mobile, product_ids) => {
  // Error Instrumentation Api , create Customer on its success

  const restApiClient = createRestApiClient();
  let web_user_id = getWebUserId();
  // product_ids = docCookies.getItem("cart_items", "/");
  const country_code = getCountryCode();
  const browser_id = getBrowserId();
  const params = {
    mobile,
    product_ids,
    web_user_id,
    random: new Date().getTime(),
    browser_id,
  };
  const api_url = 'api/webMobileLogin';
  return restApiClient
    .request({
      method: 'GET',
      url: api_url,
      params: params,
      headers: {
        authorization: getUserToken(),
        country_code: country_code,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      fireApiHandler(api_url, err);
    });
};

export const apiCallCreateOrder = (params, body) => {
  const restApiClient = createRestApiClient();
  const country_code = getCountryCode();
  const api_url = 'api/order/add';
  //const api_url = "api/order/new";
  return restApiClient
    .request({
      method: 'POST',
      url: api_url,
      params: params,
      data: body,
      headers: {
        authorization: getUserToken(),
        country_code: country_code,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      fireApiHandler(api_url, err);
    });
};

export const callbackJusPay = (params) => {
  const restApiClient = createRestApiClient();
  const api_url = 'api/callbackJusPay';
  return restApiClient
    .request({
      method: 'POST',
      url: api_url,
      params: params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      fireApiHandler(api_url, err);
    });
};

export const getEddForPaymentPage = (params) => {
  const restApiClient = createRestApiClient();
  const api_url = 'api/getEdd';
  return restApiClient
    .request({
      method: 'POST',
      url: api_url,
      data: params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      fireApiHandler(api_url, err);
    });
};
